import axios from "axios";
import API_BASE_URL from "../config";

const translations = {
    PICTURE: 'fotografía',
    POINTS: 'puntos'
};

// Función para traducir y convertir a minúsculas
const translateAndLowerCase = (str) => {
    const translation = translations[str];
    return translation ? translation.toLowerCase() : str.toLowerCase();
};

// Función para buscar y reemplazar palabras en un texto
const replaceTranslation = (text) => {
    return text.replace(/PICTURE|POINTS/g, (match) => translateAndLowerCase(match));
};

const AddPointsEventSevices = async (token, data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/registrar-puntos/`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(replaceTranslation(error.response.data.message));
    }
}

export default AddPointsEventSevices;